import React from "react";
import HeroSlider from "../components/HeroSlider";
// import AboutSection from "../components/AboutSection";
import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import Zebra from "../components/ServiceRegions/İntros/Zebra";


const Home = () => {
  return (
    <> 
    <div>
        
      <HeroSlider />
      <Zebra/>
      <ServicesGrid />
      <BlogList/>
      <Testimonials/>
      <Footer/>
     
    </div>
     </>
  );
};

export default Home;